import * as React from 'react';
import clsx from 'clsx';
import { Select } from '../Select';
import { IBLabeledSelectProps } from './LabeledSelect.types';
import { InputLabel } from '../Input/Input';

const LabeledSelect: React.FC<IBLabeledSelectProps> = (
  props: IBLabeledSelectProps
) => {
  const {
    label,
    id,
    onChange,
    className,
    labelClassName,
    value,
    options,
    disabled,
    placeholder,
    addEmptyValue,
    error,
    errorMessage,
    styleType,
    testId
  } = props;

  return (
    <div className={`labeled-select ${className}`} id={id}>
      {label && (
        <InputLabel className={clsx([labelClassName ?? ''])}>
          {label}
        </InputLabel>
      )}
      <Select
        styleType={styleType}
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        options={options}
        addEmptyValue={addEmptyValue}
        error={error}
        errorMessage={errorMessage}
        testId={testId}
      />
    </div>
  );
};

export default LabeledSelect;
